import { PopupModal } from 'components/modals/ModalBox';
import useButtonLoader from 'hooks/useButtonLoader';
import React from 'react'
import { deleteProductImageApi } from 'services/product-management';
import { toastMessage } from 'utils/toastMessage';

const DeleteImage = ({ show, close, data, listing, setState = () => { } }) => {
    const [bannerButtonLoader, setBannerButtonLoader] = useButtonLoader("Yes");
    console.log('data', data)
    const deleteUploadedImage = async () => {
        if (data?.img?.name) {
            setState((prev) => prev.filter((item, ind) => ind !== data?.index))
            close();
        } else {
            try {
                setBannerButtonLoader(true);
                const payload = {
                    productId: data?.data,
                    index: data?.index,
                }
                const {
                    data: { code, status, message },
                } = await deleteProductImageApi(payload);
                if (status || code === 200) {
                    setState((prev) => prev.filter((item, ind) => ind !== data?.index))
                    close();
                    // listing()
                    toastMessage(message, "success", "Delete Product");
                }
            } catch (e) {
                console.log("error:", e.error);
            } finally {
                setBannerButtonLoader(false);
            }
        }
    };
    return (
        <PopupModal
            show={show}
            handleClose={close}
            content="Are you sure you want to Delete this Image?"
            title="Delete Product image"
            buttonLoader={bannerButtonLoader}
            action={deleteUploadedImage}
        />
    )
}

export default DeleteImage